import api from '../Api';

export const getUsers = () => async dispatch => {
  const { data } = await api.get('/users');
  dispatch({
    type: 'FETCH_USERS',
    payload: data,
  });
};

export const clearUsers = () => ({
  type: 'CLEAR_USERS',
});

export const getUser = id => async dispatch => {
  const { data } = await api.get(`/users/${id}`);
  dispatch({
    type: 'FETCH_USER',
    payload: data,
  });
};

export const clearUser = () => ({
  type: 'CLEAR_USER',
});
